"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Depth = void 0;
exports.Depth = {
    UI: 2,
    Game: 1,
    Fluff: 0,
    Background: -1,
};
